import $ from "jquery";

$(".menu-products-toggler").click(function () {
	$(this).toggleClass("menu-products-toggler--opened");
	$(".site-header__products-wrapper").toggleClass("menu--opened");
});
